module.exports = __webpack_public_path__ + "img/protection-covid.6fa31fe0.svg";